import * as CANNON from 'cannon-es';
import * as THREE from 'three';
import CannonDebugRenderer from '../cannonDebugger/cannonDebuger';
import { portraitNames } from '../../../utils/metaData';
import { store } from '../../../store/store';
import 'three/examples/jsm/controls/OrbitControls.js';
import 'three';
import '../Events/Events';
export class PhysicsWorld {
    constructor(props) {
        this.physicsWorld = new CANNON.World({
            gravity: new CANNON.Vec3(0, -9.82, 0)
        });
        this.physicsWorld.broadphase = new CANNON.SAPBroadphase(this.physicsWorld);
        this.physicsWorld.solver.iterations = 10;
        // Camera physics
        this.sphereBody = new CANNON.Body({
            mass: 1,
            type: CANNON.Body.DYNAMIC,
            position: new CANNON.Vec3(-16.7, 1, -10),
            shape: new CANNON.Sphere(0.7)
        });
        this.planeBody = new CANNON.Body({
            type: CANNON.Body.STATIC,
            position: new CANNON.Vec3(0, 0, 0),
            shape: new CANNON.Plane()
        });
        this.planeBody.quaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), -Math.PI / 2);
        const firstStairs = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(3, 1, 1)),
            position: new CANNON.Vec3(7.3, 0.4, 7.8)
        });
        firstStairs.quaternion.setFromEuler(0, 0, 9.8);
        const secondStairs = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(2, 1, 1)),
            position: new CANNON.Vec3(8.7, 1.8, 4.4)
        });
        secondStairs.quaternion.setFromEuler(0.3, 8, 0.2);
        const holeUpstairs = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(7.6, 0.2, 8)),
            position: new CANNON.Vec3(8.6, 3.4, -4.6)
        });
        const holeUpstairsRight = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(3, 0.2, 7)),
            position: new CANNON.Vec3(12.6, 3.4, 4.4)
        });
        const cubeRight = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(0.15, 0.75, 5.8)),
            position: new CANNON.Vec3(9.5, 4.4, 9.6)
        });
        const cubeLeft = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(0.75, 0.75, 13)),
            position: new CANNON.Vec3(2.7, 4.4, -9.6)
        });
        const cubeBesideStairs = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(3.5, 0.4, 0.4)),
            position: new CANNON.Vec3(4.1, 4.4, 3.7)
        });
        const wallOne = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(5.2, 8, 25)),
            position: new CANNON.Vec3(19.5, 1.7, 2)
        });
        const wallTwo = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(6.2, 8, 25)),
            position: new CANNON.Vec3(-26, 1.7, 2)
        });
        const wallThree = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(28.1, 8, 5)),
            position: new CANNON.Vec3(-0.5, 1.7, -15.8)
        });
        const wallFour = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(28.1, 8, 5)),
            position: new CANNON.Vec3(-0.5, 1.7, 15.8)
        });
        // Shape Left
        const firstCube = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(0.4, 0.4, 9.5)),
            position: new CANNON.Vec3(-13.1, 0.7, -10)
        });
        // Podium Left
        const secondCube = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(-5.5, 0.4, 0.4)),
            position: new CANNON.Vec3(-8, 0.7, -1)
        });
        // Shape Right
        const thirdCube = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(0.4, 0.4, -6.2)),
            position: new CANNON.Vec3(-13.1, 0.7, 10)
        });
        // Podium Right
        const fourthCube = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(-5.5, 0.4, 0.4)),
            position: new CANNON.Vec3(-8, 0.7, 4.2)
        });
        // Right Marble Chair
        const rightMarbleChair = new CANNON.Body({
            shape: new CANNON.Sphere(1),
            position: new CANNON.Vec3(-6, 0.7, 5.8)
        });
        // Left Marble Chair
        const leftMarbleChair = new CANNON.Body({
            shape: new CANNON.Sphere(1),
            position: new CANNON.Vec3(-6, 0.7, -3.2)
        });
        // Artwork Wall
        const artworkWall = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(-3.5, 0.4, 0.4)),
            position: new CANNON.Vec3(6, 0.7, 3.7)
        });
        // Right Stair Wall
        const rightStairWall = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(-2, 0.4, 0.4)),
            position: new CANNON.Vec3(4.8, 0.7, 9.4)
        });
        // Receptionist Table
        const receptionistTable = new CANNON.Body({
            shape: new CANNON.Box(new CANNON.Vec3(0.4, 0.4, 2)),
            position: new CANNON.Vec3(-14.6, 0.7, -7.4)
        });
        // Top First Bench
        const topFirstBench = new CANNON.Body({
            shape: new CANNON.Sphere(1),
            position: new CANNON.Vec3(4.8, 4.4, 0)
        });
        // Top Second Bench
        const topSecondBench = new CANNON.Body({
            shape: new CANNON.Sphere(1),
            position: new CANNON.Vec3(4.8, 4.4, -5.1)
        });
        this.collissions = [];
        portraitNames.forEach((creative, index) => {
            const shape = new CANNON.Box(new CANNON.Vec3(0.75, 0.075, 0.75));
            const position = new CANNON.Vec3(creative.coordinates.x, creative.coordinates.y, creative.coordinates.z);
            const body = new CANNON.Body({
                shape,
                position,
                isTrigger: true
            });
            body.addEventListener('collide', () => {
                store.creativeIndex.update(() => index);
            });
            this.collissions.push(body);
            this.physicsWorld.addBody(body);
        });
        this.physicsWorld.addEventListener('endContact', event => {
            if ((event.bodyA === this.sphereBody && this.collissions.includes(event.bodyB)) ||
                (event.bodyB === this.sphereBody && this.collissions.includes(event.bodya))) {
                store.creativeIndex.update(() => null);
            }
        });
        this.physicsWorld.addBody(this.sphereBody);
        this.physicsWorld.addBody(this.planeBody);
        this.physicsWorld.addBody(firstStairs);
        this.physicsWorld.addBody(secondStairs);
        this.physicsWorld.addBody(holeUpstairs);
        this.physicsWorld.addBody(holeUpstairsRight);
        this.physicsWorld.addBody(cubeRight);
        this.physicsWorld.addBody(cubeLeft);
        this.physicsWorld.addBody(cubeBesideStairs);
        this.physicsWorld.addBody(wallOne);
        this.physicsWorld.addBody(wallTwo);
        this.physicsWorld.addBody(wallThree);
        this.physicsWorld.addBody(wallFour);
        this.physicsWorld.addBody(firstCube);
        this.physicsWorld.addBody(secondCube);
        this.physicsWorld.addBody(thirdCube);
        this.physicsWorld.addBody(fourthCube);
        this.physicsWorld.addBody(rightMarbleChair);
        this.physicsWorld.addBody(leftMarbleChair);
        this.physicsWorld.addBody(artworkWall);
        this.physicsWorld.addBody(rightStairWall);
        this.physicsWorld.addBody(receptionistTable);
        this.physicsWorld.addBody(topFirstBench);
        this.physicsWorld.addBody(topSecondBench);
        this.cannonDebugRenderer = new CannonDebugRenderer(props.scene, this.physicsWorld);
        /*
        this.camera = props.camera;
        this.isMobile = props.isMobile;
        if (this.isMobile) {
          this.controls = new OrbitControls(this.camera, props.el);
          this.controls.maxDistance = 1;
          this.controls.enableZoom = false;
          this.controls.enablePan = false;
          this.controls.enableDamping = false;
          this.controls.update();
        }
        */
    }
    createPhysics(name, mesh) {
        const shape = this.createTrimesh(mesh.geometry);
        const body = new CANNON.Body({
            mass: 0,
            shape: shape
        });
        if (name === 'Marble') {
            body.position.x = 7.8;
            body.position.y = 1.5;
            body.position.z = 8.3;
        }
        if (name === 'Tangga') {
            body.position.x = 8;
            body.position.y = 1.8;
            body.position.z = 8.3;
        }
        if (name === 'Upstairs') {
            body.position.x = 9.0;
            body.position.y = 4;
            body.position.z = 3;
        }
        this.physicsWorld.addBody(body);
    }
    createTrimesh(geometry) {
        const vertices = this.getVertices(geometry);
        if (!vertices.length)
            return null;
        const indices = Object.keys(vertices).map(Number);
        return new CANNON.Trimesh(vertices, indices);
    }
    getVertices(geometry) {
        const position = geometry.attributes.position;
        const vertices = new Float32Array(position.count * 3);
        for (let i = 0; i < position.count; i += 3) {
            vertices[i] = position.getX(i);
            vertices[i + 1] = position.getY(i);
            vertices[i + 2] = position.getZ(i);
        }
        return vertices;
    }
    /*
      private calculateSpeed(event: Events): THREE.Vector3 {
    
        const angle = this.controls.getAzimuthalAngle();
        let tempVector = new THREE.Vector3();
        let tempVector1 = new THREE.Vector3();
        let upVector = new THREE.Vector3(0, 1, 0);
        let scale = 3;
    
        if (event.fwdValue > 0) {
          tempVector
            .set(0, 0, -event.fwdValue)
            .applyAxisAngle(upVector, angle);
    
          tempVector1.addScaledVector(
            tempVector,
            scale
          );
        }
    
        if (event.bkdValue > 0) {
          tempVector
            .set(0, 0, event.bkdValue)
            .applyAxisAngle(upVector, angle);
    
          tempVector1.addScaledVector(
            tempVector,
            scale
          );
        }
    
        if (event.lftValue > 0) {
          tempVector
            .set(-event.lftValue, 0, 0)
            .applyAxisAngle(upVector, angle);
    
          tempVector1.addScaledVector(
            tempVector,
            scale
          );
        }
    
        if (event.rgtValue > 0) {
          tempVector
            .set(event.rgtValue, 0, 0)
            .applyAxisAngle(upVector, angle);
    
          tempVector1.addScaledVector(
            tempVector,
            scale
          );
        }
        return tempVector1;
      }
      */
    handlePhysics(props) {
        const { camera, userDirection, elapsedTime } = props;
        let oldElapsedTime = 0;
        const deltaTime = elapsedTime - oldElapsedTime;
        oldElapsedTime = elapsedTime;
        const position = new THREE.Vector3(this.sphereBody.position.x, this.sphereBody.position.y, this.sphereBody.position.z);
        // this.cannonDebugRenderer.update();
        camera.position.copy(position);
        this.sphereBody.velocity.set(userDirection.x, this.sphereBody.velocity.y, userDirection.z);
        this.physicsWorld.step(1 / 60, deltaTime, 2);
    }
}
